class ProductForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this._eventAttached = false;
    setTimeout(() => {
      this.form = this.querySelector('form');
      // <product-form> is also rendered as a placeholder in quick-shop slots
      // before the actual form has been fetched. In that case there is no
      // <form> child yet; bail out instead of throwing on null.elements,
      // which leaves an unhandled rejection that interferes with subsequent
      // ATC flows (e.g. cart drawer never opens).
      if (!this.form) return;
      this.idInput = this.form.elements['id'];
      this.submitButton = this.form.elements['add'];

      if (this.idInput) this.idInput.removeAttribute('disabled');

      this.notifyOnAdd = this.hasAttribute('notify-on-add');

      this._boundSubmit = this.submit.bind(this);

      this._eventAttached = true;
      this.form.addEventListener('submit', this._boundSubmit);
    });
  }

  disconnectedCallback() {
    if (this._eventAttached) {
      this._eventAttached = false;
      this.form.removeEventListener('submit', this._boundSubmit);
    }
  }

  async submit(e) {
    e.preventDefault();

    const data = new FormData(e.target);
    const item = Object.fromEntries(data.entries());

    try {
      this.removeError();
      await this._setIsAdding();
      await window.theme.cart.store.getState().add(item);
      await this._setIsAdding(false);

      const quickShop = this.closest('quick-shop');
      if (quickShop) {
        await quickShop.hide();
      }

      if (this.notifyOnAdd) {
        await window.theme.cart.store.getState().resetVariantsBeingAdded();
        if (!this.closest('.cart-draw')) theme.mfpOpen('cart');
      } else {
        await window.theme.cart.store.getState().resetLatestAddedProduct();
        await window.theme.cart.store
          .getState()
          .resetVariantsBeingAdded(item.id);
      }
    } catch (e) {
      this._renderError(e.message);
      await this._setIsAdding(false, true);
    }
  }

  _setIsAdding(isAdding = true, error = false) {
    return new Promise((resolve) => {
      if (!this.submitButton) {
        resolve('No submit button');
        return;
      }

      if (error) {
        this.submitButton.classList.remove('is-adding');
        resolve('error');
        return;
      }

      if (isAdding) {
        this.submitButton.classList.remove('is-added');
        this.submitButton.classList.add('is-adding');
        resolve('Adding');
      } else {
        this.submitButton.classList.remove('is-adding');
        this.submitButton.classList.add('is-added');

        // The tick animation on the child element bubbles `animationend` up
        // to the button. But if the button was already in `.is-added` (e.g.
        // a prior ATC's animationend never fired because the tab was hidden,
        // or the tick was display:none), no new animation runs and the
        // listener never fires — which silently hangs the whole submit chain
        // (cart drawer never opens, no error logged). Resolve via whichever
        // happens first: animationend OR a 1700 ms fallback (animation is
        // 1500 ms, +200 ms safety).
        let resolved = false;
        const finish = (label) => {
          if (resolved) return;
          resolved = true;
          this.submitButton.classList.remove('is-added');
          resolve(label);
        };
        this.submitButton.addEventListener(
          'animationend',
          () => finish('Added'),
          { once: true }
        );
        setTimeout(() => finish('Added-timeout'), 1700);
      }
      return;
    });
  }

  _renderError(message) {
    this.removeError();

    if (this.submitButton) {
      const error = document.createElement('div');
      error.classList.add('errors', 'qty-error', 'u-small');
      error.innerHTML = message;
      this.submitButton.after(error);
    }
  }

  removeError() {
    const error = this.querySelector('.errors');
    if (!error) return;

    error.remove();
  }
}
customElements.define('product-form', ProductForm);
